import { useState } from 'react'
import { Button } from '@mui/material'
import styled from 'styled-components'
import { AuthEmailInput, AuthPasswordInput } from '../pages/Auth/AuthForm'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { loginSchema } from 'lib'

const ReAuthModal = ({
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
  title = ''
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const {
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitted, touchedFields }
  } = useForm({
    resolver: yupResolver(loginSchema),
    mode: 'onChange',
    defaultValues: {
      email: '',
      password: ''
    }
  })

  const getError = fieldName => {
    if (isSubmitted) return errors[fieldName]?.message || ''
    return touchedFields[fieldName] && errors[fieldName]?.message
      ? errors[fieldName].message
      : ''
  }

  const [email, password] = watch(['email', 'password'])

  const handleClose = () => {
    if (!isSubmitting) {
      onClose?.()
    }
  }

  const handleInputChange = event => {
    const { name, value } = event.target
    setValue(name, value, {
      shouldValidate: true
    })
  }

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const onSubmit = async formData => {
    const confirmData = { email: formData.email, password: formData.password }
    onConfirm?.(confirmData)
  }

  if (!open) {
    return null
  }

  return (
    <Overlay>
      <ModalCard>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Header>{title}</Header>
          <Body>
            <AuthEmailInput
              email={email}
              handleInputChange={handleInputChange}
              disabled={isSubmitting}
              error={getError('email')}
            />
            <AuthPasswordInput
              password={password}
              handleInputChange={handleInputChange}
              showPassword={showPassword}
              handlePasswordVisibility={handlePasswordVisibility}
              disabled={isSubmitting}
              error={getError('password')}
            />
          </Body>
          <Footer>
            <Button onClick={handleClose} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="outlined"
              disabled={!email || !password || isSubmitting}
              sx={{
                backgroundColor: '#FFC107',
                color: 'black'
              }}
            >
              {isSubmitting ? 'Verifying...' : 'Confirm'}
            </Button>
          </Footer>
        </form>
      </ModalCard>
    </Overlay>
  )
}

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
`

const ModalCard = styled.div`
  background: #ffffff;
  border-radius: 8px;
  min-width: 400px;
  max-width: 480px;
  padding: 24px 24px 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
`

const Header = styled.h3`
  margin: 0 0 16px;
  font-size: 18px;
  font-weight: 600;
`

const Body = styled.div`
  margin-bottom: 16px;
`

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`

export default ReAuthModal
